import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'

const GroupMessageIcon = () => {
  return (
    <Box>
			<Avatar variant='rounded'sx={{width:'70px', height:'70px'}}>
			</Avatar>
    </Box>
  )
}

export default GroupMessageIcon
